const CrossInFilledCircle = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12 1C5.93436 1 1 5.93436 1 12C1 18.0656 5.93436 23 12 23C18.0656 23 23 18.0656 23 12C23 5.93436 18.0656 1 12 1ZM16.0508 14.7545C16.4092 15.1131 16.4092 15.6923 16.0508 16.0508C15.8721 16.2296 15.6374 16.3194 15.4026 16.3194C15.1679 16.3194 14.9333 16.2296 14.7545 16.0508L12 13.2961L9.24547 16.0508C9.06671 16.2296 8.83206 16.3194 8.59741 16.3194C8.36259 16.3194 8.12794 16.2296 7.94919 16.0508C7.59084 15.6923 7.59084 15.1131 7.94919 14.7545L10.7039 12L7.94919 9.24547C7.59084 8.88695 7.59084 8.30771 7.94919 7.94919C8.30771 7.59084 8.88695 7.59084 9.24547 7.94919L12 10.7039L14.7545 7.94919C15.1131 7.59084 15.6923 7.59084 16.0508 7.94919C16.4092 8.30771 16.4092 8.88695 16.0508 9.24547L13.2961 12L16.0508 14.7545Z" />
    </svg>
  );
};

export default CrossInFilledCircle;
